import { Injectable, TemplateRef } from '@angular/core';
import { NgbModal, NgbModalOptions, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ModalOptions } from '../components/global-modal/modal-options';
import { ModalType } from '../components/global-modal/modal-type';

@Injectable({
  providedIn: 'root'
})
export class GlobalModalService {
  template: TemplateRef<unknown>;
  modal: NgbModalRef;
  options: ModalOptions;

  constructor(private modalService: NgbModal) {}

  /**
   * Opens a confirmation modal (OK and Cancel buttons)
   *
   * @param options the options for the modal
   * @param ngbModalOptions `NgbModalOptions` for the modal
   * @returns A promise that is fulfilled when the user chooses to confirm, and rejected when
   *          the user chooses not to confirm, or closes the modal.
   */
  confirm(options: ModalOptions, ngbModalOptions?: NgbModalOptions): Promise<unknown> {
    return this.open({ ...options, modalType: ModalType.CONFIRM }, ngbModalOptions);
  }

  /**
   * Opens a confirmation modal (2 OK buttons and a Cancel button)
   *
   * @param options the options for the modal
   * @param ngbModalOptions `NgbModalOptions` for the modal
   * @returns A promise that is fulfilled when the user chooses to confirm, and rejected when
   *          the user chooses not to confirm, or closes the modal.
   */
  confirmSecondary(options: ModalOptions, ngbModalOptions?: NgbModalOptions): Promise<unknown> {
    return this.open({ ...options, modalType: ModalType.CONFIRM_SECONDARY }, ngbModalOptions);
  }

  /**
   * Opens an alert modal (OK button only)
   *
   * @param options the options for the modal
   * @param ngbModalOptions `NgbModalOptions` for the modal
   * @returns A promise that is fulfilled when the user chooses to confirm, and rejected when
   *          the user chooses not to confirm, or closes the modal.
   */
  alert(options: ModalOptions, ngbModalOptions?: NgbModalOptions): Promise<unknown> {
    return this.open({ ...options, modalType: ModalType.ALERT }, ngbModalOptions);
  }

  private open(options: ModalOptions, ngbModalOptions?: NgbModalOptions): Promise<unknown> {
    if (this.modal) {
      // Only one instance of this modal should be open at a time since we can only store a reference to one
      this.modal.dismiss();
    }

    this.options = {
      ...new ModalOptions(),
      ...options
    };

    this.modal = this.modalService.open(this.template, ngbModalOptions);

    return this.modal.result;
  }
}
